import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'utils/createIcon';

import ExclamationFillIcon from 'common/icons/ExclamationFill';
import { ErrorMessage, ErrorMessageText } from './FormErrorWithIcon.styles';

const FormErrorWithIcon = (props) => (
    <ErrorMessage>
        <Icon icon={ExclamationFillIcon} />
        <ErrorMessageText>{props.message}</ErrorMessageText>
    </ErrorMessage>
);

FormErrorWithIcon.propTypes = {
    message: PropTypes.string.isRequired,
};

FormErrorWithIcon.defaultProps = {};

export default FormErrorWithIcon;
